import { render, staticRenderFns } from "./SortPriority.vue?vue&type=template&id=133ad932&scoped=true&"
import script from "./SortPriority.vue?vue&type=script&lang=js&"
export * from "./SortPriority.vue?vue&type=script&lang=js&"
import style0 from "./SortPriority.vue?vue&type=style&index=0&id=133ad932&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "133ad932",
  null
  
)

export default component.exports